/** @jsx h */

import { h, render } from "preact";

const Intro = props => {
  return (
    
      <div className="intro-wrapper">
        <h2 className="intro1 slide">Tyler Gregg,</h2>
        <h2 className="intro2 slide">Full Stack</h2>
        <h2 className="intro3 slide">Developer.</h2>
      </div>
    
  );
};

export default Intro;
